module.exports = __webpack_public_path__ + "img/jo1.bfb22e71.png";